/**
 * Forked from: https://github.com/reevoo/react-multiline-ellipsis/blob/master/src/index.jsx
 */
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

export const ellipsis = (ComposedComponent, maxLines, ellipsisText = '...') => {
  class ReactMultilineEllipsis extends Component {
    constructor(props) {
      super(props);
      this.state = {
        text: `${props.text}`,
      };
      this.checkEllipsis = debounce(this.checkEllipsis, 50);
    }

    componentDidMount() {
      this.checkEllipsis();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.containerWidth !== nextProps.containerWidth) {
        this.checkEllipsis();
      }
    }

    shouldComponentUpdate(nextProps, nextState) {
      if (
        this.props.containerWidth !== nextProps.containerWidth ||
        this.state.text !== nextState.text
      ) {
        return true;
      }
      return false;
    }

    getDOMNodeProperty = (node, property) => {
      return document.defaultView
        .getComputedStyle(node, null)
        .getPropertyValue(property);
    };

    findNumberOfLines = () => {
      const node = findDOMNode(this.component);
      const lineHeight = this.getDOMNodeProperty(node, 'line-height').replace(
        'px',
        '',
      );
      const height = this.getDOMNodeProperty(node, 'height').replace('px', '');

      return Math.ceil(height / lineHeight);
    };

    truncateText = currentText => {
      let ellipsedText = currentText.substring(0, currentText.lastIndexOf(' '));
      if (this.startsWith(ellipsisText, ' ')) {
        ellipsedText = ellipsedText.substring(0, ellipsedText.lastIndexOf(' '));
      }
      return `${ellipsedText}${ellipsisText}`;
    };

    checkEllipsis() {
      if (!this.component) return;
      const numberOfLines = this.findNumberOfLines();
      if (numberOfLines > maxLines) {
        const text = this.truncateText(this.props.text);
        return this.setState({ text, numberOfLines }, this.checkEllipsisText);
      } else if (numberOfLines <= this.state.numberOfLines) {
        return this.setState(
          { text: this.props.text, numberOfLines },
          this.checkEllipsisText,
        );
      }
    }

    checkEllipsisText() {
      if (!this.component) return;
      const numberOfLines = this.findNumberOfLines();
      if (numberOfLines > maxLines) {
        const text = this.truncateText(this.state.text);
        return this.setState({ text, numberOfLines }, this.checkEllipsisText);
      }
    }

    startsWith = (str, textToSearch) => {
      return str.startsWith
        ? str.startsWith(textToSearch)
        : str.indexOf(textToSearch, 0) === 0;
    };

    ref = undefined;

    render() {
      return (
        <ComposedComponent
          ref={ref => {
            this.component = ref;
          }}
          {...this.props}
          {...this.state}
        />
      );
    }
  }

  ReactMultilineEllipsis.propTypes = {
    text: PropTypes.string.isRequired,
  };

  return ReactMultilineEllipsis;
};
